// extracted by css-extract-rspack-plugin
export default {"empty-frame-hidden":"Uxfeedback-module__empty-frame-hidden--Bz81z","emptyFrameHidden":"Uxfeedback-module__empty-frame-hidden--Bz81z"};